(function () {
  'use strict';

  /* Mobile navigation ------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;
    var isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* Search drawer ---------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-search-toggle]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    panel.open = !panel.open;
    if (panel.open) {
      var input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  });

  /* Announcement rotator --------------------------------------------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-announcement-slide]'));
    if (slides.length < 2) return;
    var index = 0;
    var timer = null;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;

    function show(next) {
      slides[index].hidden = true;
      index = (next + slides.length) % slides.length;
      slides[index].hidden = false;
    }
    function start() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () { show(index + 1); }, interval);
    }
    function stop() { if (timer) window.clearInterval(timer); timer = null; }

    bar.querySelectorAll('[data-announcement-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { stop(); show(index - 1); start(); });
    });
    bar.querySelectorAll('[data-announcement-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { stop(); show(index + 1); start(); });
    });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    start();
  });

  /* Product gallery + variant picker --------------------------------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var mainImage = root.querySelector('[data-product-main-image]');

    root.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (mainImage && full) {
          mainImage.src = full;
          mainImage.srcset = '';
        }
        root.querySelectorAll('[data-product-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });

    var select = root.querySelector('[data-variant-select]');
    if (!select) return;
    var priceEl = root.querySelector('[data-product-price]');
    var button = root.querySelector('[data-add-button]');
    var variants = [];
    var dataEl = root.querySelector('[data-variant-json]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    select.addEventListener('change', function () {
      var id = parseInt(select.value, 10);
      var variant = variants.filter(function (v) { return v.id === id; })[0];
      if (!variant) return;
      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available
          ? button.getAttribute('data-label-add')
          : button.getAttribute('data-label-soldout');
      }
      if (variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image;
        mainImage.srcset = '';
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  /* Cart quantity auto-submit ---------------------------------------- */
  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    cartForm.querySelectorAll('[data-quantity-input]').forEach(function (input) {
      input.addEventListener('change', function () { cartForm.submit(); });
    });
  }
})();
